export class GTag {
  private readonly dataLayer: any[];
  private readonly trackingId: string;

  constructor(trackingId: string) {
    this.trackingId = trackingId;
    this.dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer = this.dataLayer;

    this.gtag('js', new Date());
    this.gtag('config', trackingId);

    this.loadScript();
  }

  public trackEvent(eventName: string, metric?: number, category?: string, label?: string) {
    this.gtag('event', eventName, {
      event_category: category,
      event_label: label,
      value: metric
    });
  }

  private gtag(...args: any[]) {
    this.dataLayer.push(args);
  }

  private loadScript() {
    if (process.env.NODE_ENV !== 'production') return;
    const script = window.document.createElement('script') as HTMLScriptElement;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.trackingId}`;
    window.document.head.appendChild(script);
  }
}
